export default __webpack_public_path__ + "static/char-s-15-en-5102f80c7e89776eda8b25ef0d95b665.png";